import type { Painter } from '../rendering/Painter';
import { overlayTokens } from '../styles/tokens';
import type { InstructionsBarVM } from '../vm/types';

export class InstructionsBar {
    render(painter: Painter, vm: InstructionsBarVM): void {
        painter.panel(vm.rect, 'rgba(0,0,0,0.6)', 'rgba(0,0,0,0)');
        painter.text(
            vm.text,
            vm.rect.x + 8,
            vm.rect.y + 4,
            overlayTokens.colors.text,
            overlayTokens.fonts.small,
        );
    }
}
